import React, { createContext, useCallback, useContext, useEffect, useMemo, useState } from 'react';
import { LANGS, translations } from '@/i18n/translations';

const STORAGE_KEY = 'spunkram_lang';
const DEFAULT_LANG = 'tr';

const LanguageContext = createContext(null);

const readStored = () => {
  try {
    const v = localStorage.getItem(STORAGE_KEY);
    if (v && translations[v]) return v;
  } catch (e) {
    /* ignore */
  }
  return DEFAULT_LANG;
};

export const LanguageProvider = ({ children }) => {
  const [lang, setLangState] = useState(readStored);

  useEffect(() => {
    try {
      localStorage.setItem(STORAGE_KEY, lang);
    } catch (e) {
      /* ignore */
    }
    document.documentElement.lang = lang;
  }, [lang]);

  const setLang = useCallback((next) => {
    if (translations[next]) setLangState(next);
  }, []);

  const t = useCallback(
    (key, vars) => {
      const dict = translations[lang] || translations[DEFAULT_LANG];
      let str = dict[key];
      if (str === undefined) str = translations[DEFAULT_LANG][key];
      if (str === undefined) return key;
      if (vars) {
        Object.keys(vars).forEach((k) => {
          str = str.split(`{${k}}`).join(String(vars[k]));
        });
      }
      return str;
    },
    [lang]
  );

  const value = useMemo(() => ({ lang, setLang, t, langs: LANGS }), [lang, setLang, t]);

  return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
};

export const useI18n = () => {
  const ctx = useContext(LanguageContext);
  if (!ctx) {
    return { lang: DEFAULT_LANG, setLang: () => {}, t: (k) => translations[DEFAULT_LANG][k] || k, langs: LANGS };
  }
  return ctx;
};
